export default function typingDots(hidden) {
	return $("<span class='chat-dots'"+(hidden ? " style='visibility:hidden'":"")+"><span class='chat-dot1'>.</span><span class='chat-dot2'>.</span><span class='chat-dot3'>.</span></span>");
};
